function buildPath(path: string, params: { [key: string]: string | number }): string {
  const symbol = ':';
  let text = path;

  // replace with provided params
  for (const key in params) {
    const param = `${symbol}${key}`;
    const value = String(params[key]);

    text = text.replace(param, value);
  }

  // verify all params have been replaced
  if (text.includes(symbol)) {
    const segments = text.split('/');

    segments.forEach((segment) => {
      if (!segment.includes(symbol)) {
        return;
      }

      const missing = segment.substring(1);

      if (missing) {
        throw new Error(`\`${path}\` expects missing param \`${missing}\``);
      }
    });
  }

  return text;
}

export default buildPath;
